import { Tab } from '@sravni/ugc/lib/specialOffers/types';

import { IGlobalState } from '../reducers';

export const getSpecialOffersPopupTabs = (state: IGlobalState): Tab[] => state.specialOffers.tabs;
